import { Component, OnInit } from '@angular/core';
import { AbstractCalculatorComponentEmitsValue } from '../abstract-calculator-component-emits-value.directive';
import { enumToOptions, enumValuesToOptions, SelectOption } from '../../../../inputs/select/model/select-option';
import { ETypeCalculation } from '../../../../models/analysis/solar-calculator-request';
import { PriceCountry, PriceType } from '../../../../models/price/price';
import { AbstractControl } from '@angular/forms';
import { inOutAnimation } from '../../../../animations';

@Component({
  selector: 'psc-calculator-tariff-group-selector',
  templateUrl: './calculator-tariff-group-selector.component.html',
  animations: [
    inOutAnimation({}),
  ],
})
export class CalculatorTariffGroupSelectorComponent extends AbstractCalculatorComponentEmitsValue implements OnInit {

  tariffGroupDisabled: boolean = true;
  tariffModelOptions: SelectOption[];
  loadingTariffs: boolean;

  typeCalculationDisabled: boolean;
  typeCalculationOptions: SelectOption[] = enumToOptions(ETypeCalculation);

  get controlName(): string {
    return 'tariff_group';
  }

  get typeCalculationControl(): AbstractControl {
    return this.formGroup.controls['type_calculation'];
  }

  override ngOnInit() {
    super.ngOnInit();
    this.subs.add(
      this.manager.country.subscribe((value) => {
        this.control?.reset();
        this.tariffGroupDisabled = true;
      }),
      this.manager.supplier.subscribe((value) => {
        this.control?.reset();
        this.tariffGroupDisabled = true;
        if (!value) {
          return;
        }
        this.loadingTariffs = true;
        this.priceService.getTariffModels(this.formGroup.controls['country']?.value, value, this.getCalculatorPrivacyStatus()).subscribe((values) => {
          this.manager.tariffModelValues = values;
          this.tariffModelOptions = values.map((tariffModel) => ({
            label: tariffModel.tariffModel,
            value: tariffModel.priceId,
          }));
          if (!this.advanced) {
            this.control?.setValue(this.tariffModelOptions[0].value);
          }
          this.tariffGroupDisabled = false;
        }).add(() => {
          this.loadingTariffs = false;
        });
      }),
      this.manager.tariff_group.subscribe((value) => {
        this.typeCalculationDisabled = true;
        if (!value) {
          this.typeCalculationControl?.reset();
          return;
        }
        const selectedTariff = this.manager.tariffModelValues.find(model => model.priceId === value);

        // Non-advanced calculator logic
        if (!this.advanced) {
          let selectedEnum: ETypeCalculation;
          switch (this.formGroup.controls['country']?.value) {
            case PriceCountry.BA_RS:
              selectedEnum = ETypeCalculation.BA_RS_FEED_IN_NET;
              break;
            case PriceCountry.BA_FE:
              selectedEnum = ETypeCalculation.BA_FE_FEED_IN_NET;
              break;
            case PriceCountry.HR:
            default:
              selectedEnum = ETypeCalculation.HR_FEED_IN_NET;
              break;
          }
          if (this.typeCalculationControl.value === selectedEnum) {
            return;
          }
          this.typeCalculationOptions = enumValuesToOptions([selectedEnum]);
          this.changeDetector.detectChanges();
          this.typeCalculationControl.setValue(selectedEnum);
          this.formGroup.updateValueAndValidity();
          this.changeDetector.detectChanges();
          return;
        }

        let selectableValues = [ETypeCalculation.NO_FEED_IN_ENERGY];
        let selectedEnum: ETypeCalculation;
        switch (this.formGroup.controls['country']?.value) {
          case PriceCountry.BA_FE:
            selectableValues.push(ETypeCalculation.BA_FE_FEED_IN_CALC);
            selectedEnum = ETypeCalculation.BA_FE_FEED_IN_CALC;
            if (selectedTariff?.type === PriceType.HOME) {
              selectableValues.push(ETypeCalculation.BA_FE_FEED_IN_NET);
              selectedEnum = ETypeCalculation.BA_FE_FEED_IN_NET;
            }
            break;
          case PriceCountry.BA_RS:
            if (selectedTariff?.type === PriceType.HOME) {
              selectableValues = [ETypeCalculation.BA_RS_FEED_IN_NET];
              selectedEnum = ETypeCalculation.BA_RS_FEED_IN_NET;
            } else {
              selectableValues.push(ETypeCalculation.BA_RS_FEED_IN_CALC);
              selectedEnum = ETypeCalculation.BA_RS_FEED_IN_CALC;
            }
            break;
          case PriceCountry.HR:
          default:
            selectableValues.push(ETypeCalculation.HR_FEED_IN_CALC);
            selectedEnum = ETypeCalculation.HR_FEED_IN_CALC;
            if (selectedTariff?.type === PriceType.HOME) {
              selectableValues.push(ETypeCalculation.HR_FEED_IN_NET);
              selectedEnum = ETypeCalculation.HR_FEED_IN_NET;
            }
            break;
        }
        this.typeCalculationOptions = enumValuesToOptions(selectableValues);
        this.changeDetector.detectChanges();
        this.typeCalculationDisabled = false;
        this.typeCalculationControl.setValue(selectedEnum);
        this.changeDetector.detectChanges();
        this.formGroup.updateValueAndValidity();
      }),
      this.typeCalculationControl.valueChanges.subscribe((value) => {
        this.manager.type_calculation.next(value);
      }),
    );
  }

}
